import cloneDeep from 'lodash/cloneDeep';

import * as constants from './constants';
import { createReducer } from '../../utils';

const initialState = {
  cmsRawData: null,
  isInvalid: true,
  validTill: null, // Set to an hour from the timestamp when the state has valid data
  initialStateBackup: {},
};

export default createReducer(initialState, {
  [constants.SET_INITIAL_CMS_DATA_STATE]: (
    state,
    { data, isInvalid = true },
  ) => ({
    ...state,
    ...data,
    isInvalid,
    initialStateBackup: {
      ...cloneDeep(data),
    },
  }),
  [constants.SET_CMS_DATA_IS_INVALID]: (
    state,
    { isInvalid },
  ) => ({
    ...state,
    isInvalid,
    validTill: !isInvalid ? (Date.now() + (60 * 60 * 1000)) : null,
  }),
  [constants.UPDATE_CMS_RAW_DATA]: (
    state,
    { cmsRawData },
  ) => ({
    ...state,
    cmsRawData,
  }),
  [constants.RESET_CMS_DATA]: (
    state,
  ) => {
    const data = state.initialStateBackup;

    return {
      ...state,
      ...cloneDeep(data),
      validTill: null,
    };
  },
});
